import { render, staticRenderFns } from "./patient_payments.vue?vue&type=template&id=c30c6f78&"
import script from "./patient_payments.vue?vue&type=script&lang=js&"
export * from "./patient_payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports